export const informationLink =
  "https://www.smartiscity.gr/%ce%b5%cf%86%ce%b1%cf%81%ce%bc%ce%bf%ce%b3%ce%ad%cf%82-%ce%ad%ce%be%cf%85%cf%80%ce%bd%ce%b7%cf%82-%cf%80%cf%8c%ce%bb%ce%b7%cf%82-%ce%b4%ce%ae%ce%bc%ce%bf%cf%85-%ce%bc%ce%b1%cf%81%ce%b1%ce%b8%cf%8e/";
export const informationLinkEN =
  "https://www.smartiscity.gr/%ce%b5%cf%86%ce%b1%cf%81%ce%bc%ce%bf%ce%b3%ce%ad%cf%82-%ce%ad%ce%be%cf%85%cf%80%ce%bd%ce%b7%cf%82-%cf%80%cf%8c%ce%bb%ce%b7%cf%82-%ce%b4%ce%ae%ce%bc%ce%bf%cf%85-%ce%bc%ce%b1%cf%81%ce%b1%ce%b8%cf%8e/";

export const androidAppLink =
  "https://play.google.com/store/apps/details?id=com.optionsnet.patrasmartcity";
export const iosAppLink =
  "https://apps.apple.com/gr/app/patras-smartcity/id6743700241?platform=iphone";

export const welcomeMessageContent = [
  "Ο Δήμος Πατρέων σας καλωσορίζει στην Πλατφόρμα Εξυπνης Πόλης.",
  "Ενημερωθείτε για τις συνθήκες που επικρατούν στην πόλη μας.",
];

export const baseUrl = "https://marathonas.smartiscity.gr";

export const allTypesUrl = baseUrl + "/api/api.php?func=sensortypes";
export const allSensorsUrl = baseUrl + "/api/api.php?func=allsensors";

export const UvUrl = baseUrl + "/api/api.php?func=indexes";
export const enviURL = baseUrl + "/api/api.php?func=envi";
export const meshURL = baseUrl + "/api/api.php?func=mesh";
export const meteoURL = baseUrl + "/api/api.php?func=meteo";
export const poiURL = baseUrl + "/api/api.php?func=pois";
export const fleetoUrl = baseUrl + "/api/api.php?func=fleeto";
export const binsUrl = baseUrl + "/api/api.php?func=bins";
export const hydroUrl = baseUrl + "/api/api.php?func=hydro";
export const weatherUrl = baseUrl + "/api/api.php?func=forecast";
export const wifiUrl = baseUrl + "/api/api.php?func=hotspot";
export const chartsUrls = baseUrl + "/api/api.php?func=stats";
export const parkingUrl = baseUrl + "/api/api.php?func=parkingAll";
export const publicParkingUrl = baseUrl + "/api/api.php?func=publicparking";
export const gallerySmall = baseUrl + "/gallery/vars/Small/";
export const galleryBig = baseUrl + "/gallery/vars/Big/";
export const waterqURL = baseUrl + "/api/api.php?func=waterq";

export const cityCenter = {
  lat: 38.247195,
  lng: 21.734945,
};

// settings
export const showEnvironmentAddress = true;
